import React, {useState} from "react";
import styles from  "./Button.module.scss";

export const BUTTON_TYPE_PRIMARY = 'BUTTON_TYPE_PRIMARY';
export const BUTTON_TYPE_PRIMARY_BRIGHT = 'BUTTON_TYPE_PRIMARY_BRIGHT';
export const BUTTON_TYPE_PRIMARY_PURPLE = 'BUTTON_TYPE_PURPLE';
export const BUTTON_TYPE_PRIMARY_YELLOW = 'BUTTON_TYPE_PRIMARY_YELLOW';
export const BUTTON_TYPE_PRIMARY_RED = 'BUTTON_TYPE_PRIMARY_RED';
export const BUTTON_TYPE_PRIMARY_GREEN = 'BUTTON_TYPE_PRIMARY_GREEN';
export const BUTTON_TYPE_PRIMARY_CYAN = 'BUTTON_TYPE_PRIMARY_CYAN';
export const BUTTON_TYPE_SECONDARY = 'BUTTON_TYPE_SECONDARY';
export const BUTTON_TYPE_SECONDARY_PURPLE = 'BUTTON_TYPE_SECONDARY_PURPLE';
export const BUTTON_TYPE_SECONDARY_BLUE = 'BUTTON_TYPE_SECONDARY_BLUE';
export const BUTTON_TYPE_NO_STYLE = 'BUTTON_TYPE_NO_STYLE';

function Button(props) {
    const {
        text,
        Icon,
        LeftIcon,
        buttonType = BUTTON_TYPE_PRIMARY,
        disabled = false,
        onClick,
        className,
        htmlType,
        dataTip,
        tooltip,
        inActive,
        customInactiveClassName,
        fullWidth
    } = props;

    function buttonClassnameGenerator() {
        let className;
        switch (buttonType) {
            case BUTTON_TYPE_PRIMARY:
                className = styles.primary;
                break;
            case BUTTON_TYPE_PRIMARY_BRIGHT:
                className = styles.primaryLight;
                break;
            case BUTTON_TYPE_PRIMARY_PURPLE:
                className = styles.primaryPurple;
                break;
            case BUTTON_TYPE_PRIMARY_YELLOW:
                className = styles.primaryYellow;
                break;
            case BUTTON_TYPE_PRIMARY_RED:
                className = styles.primaryRed;
                break;
            case BUTTON_TYPE_PRIMARY_GREEN:
                className = styles.primaryGreen;
                break;
            case BUTTON_TYPE_PRIMARY_CYAN:
                className = styles.primaryCyan;
                break;
            case BUTTON_TYPE_SECONDARY: 
                className = styles.secondary;
                break;
            case BUTTON_TYPE_SECONDARY_PURPLE:
                className = styles.secondaryPurple;
                break;
            case BUTTON_TYPE_SECONDARY_BLUE:
                className = styles.secondaryBlue;
                break;
            case BUTTON_TYPE_NO_STYLE: 
                className = styles.noStyle;
                break;
            default: 
                break;

        }
        return className;
    }

    const _onClick = () => {
        if (onClick && !disabled) {
            onClick();
        }
    }

    const renderIcon = () => {
        if (!Icon) {
            return;
        }

        return <Icon className={styles.buttonIcon} />
    }

    const buttonClassname = buttonClassnameGenerator();

  return (
      <button 
        onClick={() => _onClick()}
        style={{width: fullWidth ? '100%' : 'fit-content'}}
        className={`
        ${buttonClassname} 
        ${className} 
        ${inActive ? (customInactiveClassName ? customInactiveClassName : styles.inActive) : ''}`}
        type={htmlType}
        data-for={dataTip}
        data-tip={tooltip}
        disabled={disabled}>
          {LeftIcon && <LeftIcon className={`${styles.buttonIcon} ${styles.leftIcon}`} /> }
          {text}
          {renderIcon()}
      </button>
  );
}

export default Button;
